interface ProcessStepProps {
  step: number;
  icon: string;
  title: string;
}

export default function ProcessStep({ step, icon, title }: ProcessStepProps) {
  return (
    <div className="flex flex-col items-center text-center relative group cursor-default">
      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-4 relative z-10 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
        <i className={`${icon} text-xl md:text-2xl`}></i>
      </div>
      <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-2 group-hover:text-primary-400 transition-colors duration-300">
        Etapa {step}
      </span>
      <p className="text-sm md:text-base font-semibold text-foreground-800 font-heading group-hover:text-foreground-900 transition-colors duration-300">
        {title}
      </p>
    </div>
  );
}